import gsap from 'gsap'
import { SplitText } from "../../../plugins/gsap/SplitText"
import HeroGrid from "./HeroGrid";

gsap.registerPlugin(SplitText)

export default class HeroAnimation {
    constructor() {
        this.initElements();
        this.initGrid();
        this.initHeadings();
        // this.initAnimations();
    }

    initElements() {
        this.heroEl = document.getElementById('hero')
        this.logoEl = this.heroEl.querySelector('.hero--logo')
        this.titleEl = this.heroEl.querySelector('.hero--title')
        this.headingEl = this.heroEl.querySelector('.hero--heading')
    }

    initGrid() {
        this.grid = new HeroGrid(this.heroEl)
    }

    positionArrows() {
        const initialShift = -15;
        const arrowGap = 12;

        this.subtitles.forEach((subtitle, index) => {
            if (!subtitle.chars || !subtitle.chars.length || !this.arrows[index]) return;

            const lastChar = subtitle.chars[subtitle.chars.length - 1]
            const arrow = this.arrows[index]

            // Ensure elements are present and visible
            if (!lastChar || !arrow) return;

            // Get fresh bounds after character is fully visible
            const charRect = lastChar.getBoundingClientRect()
            const headingRect = this.headingEl.getBoundingClientRect()

            // Add a small delay to ensure proper positioning
            gsap.set(arrow, {
                position: 'absolute', // Ensure absolute positioning
                left: `${charRect.right - headingRect.left + arrowGap}px`,
                top: `${charRect.top - headingRect.top - initialShift}px`
            })
        })
    }

    initHeadings() {
        this.subtitleEls = this.headingEl.querySelectorAll('h2')
        this.subtitlesTextEls = this.headingEl.querySelectorAll('.heading-text')

        this.subtitles = []
        this.arrows = []

        this.slogansTimeline = gsap.timeline({
            repeat: -1,
            repeatDelay: 0.5
        })

        this.subtitlesTextEls.forEach((subtitleTextEl, index) => {
            const subtitle = new SplitText(subtitleTextEl, {
                type: 'lines, words, chars',
                charsClass: 'js-letter'
            })

            subtitle.chars.forEach((char) => {
                char.innerHTML = '<div class="js-inner">' + char.innerHTML + '</div>'
            })

            const arrow = this.subtitleEls[index].querySelector('.arrow-up-right')
            this.arrows.push(arrow)

            // Set initial states
            gsap.set(subtitle.chars, {
                opacity: 0
            })

            gsap.set(arrow, {
                opacity: 0,
                scale: 0.5,
                position: 'absolute',
                x: -20,
                y: 20
            })

            // Typing effect configuration
            const typingDuration = 0.08
            const backspaceDuration = typingDuration / 3
            const holdDuration = 2

            this.slogansTimeline
                // Type in characters one by one
                .to(subtitle.chars, {
                    opacity: 1,
                    duration: typingDuration,
                    stagger: typingDuration,
                    onComplete: () => {
                        // Position arrow after all characters are visible
                        this.positionArrows()
                    }
                })
                // Small pause to ensure positioning is complete
                .to({}, { duration: 0.1 })
                // Animate in arrow
                .to(arrow, {
                    opacity: 1,
                    scale: 1,
                    x: 0,
                    y: 0,
                    duration: 0.4,
                    ease: 'back.out(1.7)'
                })
                // Hold complete state
                .to({}, { duration: holdDuration })
                // Hide arrow
                .to(arrow, {
                    opacity: 0,
                    scale: 0.8,
                    x: 20,
                    y: -20,
                    duration: 0.3,
                    ease: 'power2.in'
                })
                // Backspace effect
                .to(subtitle.chars, {
                    opacity: 0,
                    duration: backspaceDuration,
                    stagger: {
                        each: backspaceDuration,
                        from: 'end'
                    }
                })
                // Pause before next word
                .to({}, { duration: 0.5 })

            this.subtitles.push(subtitle)
        })

        this.slogansTimeline.pause()

        window.addEventListener('introTitleComplete', () => {
            if(this.slogansTimeline.paused()) {
                this.slogansTimeline.play()
            }
        })
    }

    initAnimations() {
        this.introTimeline = gsap.timeline()

        this.introTimeline
            .to(this.logoEl, {
                duration: 1,
                y: 0,
                force3D: true,
                opacity: 1,
                ease: 'power4.out'
            })
            .to(this.titleEl, {
                duration: 1,
                opacity: 1,
                y: 0,
                force3D: true,
                ease: 'power4.out',
                onComplete: () => {
                    this.slogansTimeline.play()
                }
            }, '-=0.5')
            .to(this.headingEl, {
                duration: 1,
                opacity: 1,
                y: 0,
                force3D: true,
                ease: 'power4.out'
            }, '-=0.5')
    }

    resize() {
        this.positionArrows()
        this.grid.resize()
    }

    pause() {
        this.slogansTimeline.pause()
    }

    play() {
        this.slogansTimeline.play()
    }

    destroy() {
        this.slogansTimeline.kill()
        this.introTimeline.kill()
        this.subtitles.forEach(subtitle => subtitle.revert())
    }
}
